var _rect, _rect2, _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _g, _g2, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFestivalSeason(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "#FFF8E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 780,
    height: 180,
    rx: 8,
    fill: "none",
    stroke: "#E65100",
    strokeWidth: 2,
    strokeDasharray: "4 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 40             Q100 10, 150 40             Q200 70, 250 40             Q300 10, 350 40             Q400 70, 450 40             Q500 10, 550 40             Q600 70, 650 40             Q700 10, 750 40",
    fill: "none",
    stroke: "#E65100",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 160             Q100 130, 150 160             Q200 190, 250 160             Q300 130, 350 160             Q400 190, 450 160             Q500 130, 550 160             Q600 190, 650 160             Q700 130, 750 160",
    fill: "none",
    stroke: "#E65100",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 40,
    r: 5,
    fill: "#FF9800"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 40,
    r: 5,
    fill: "#F57C00"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 40,
    r: 5,
    fill: "#FF9800"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 40,
    r: 5,
    fill: "#F57C00"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 40,
    r: 5,
    fill: "#FF9800"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 40,
    r: 5,
    fill: "#F57C00"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 40,
    r: 5,
    fill: "#FF9800"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 40,
    r: 5,
    fill: "#F57C00"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 160,
    r: 5,
    fill: "#F57C00"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 160,
    r: 5,
    fill: "#FF9800"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 160,
    r: 5,
    fill: "#F57C00"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 160,
    r: 5,
    fill: "#FF9800"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 160,
    r: 5,
    fill: "#F57C00"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 160,
    r: 5,
    fill: "#FF9800"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 160,
    r: 5,
    fill: "#F57C00"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 160,
    r: 5,
    fill: "#FF9800"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(70, 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10 0 L10 0 L5 20 L-5 20 Z",
    fill: "#E65100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5 Q-5 -15, 0 -25 Q5 -15, 0 -5 Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -15,
    r: 2,
    fill: "#FFCC80"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(730, 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10 0 L10 0 L5 20 L-5 20 Z",
    fill: "#E65100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -5 Q-5 -15, 0 -25 Q5 -15, 0 -5 Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -15,
    r: 2,
    fill: "#FFCC80"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 80,
    fontFamily: "Arial, sans-serif",
    fontSize: 40,
    fontWeight: "bold",
    fill: "#E65100",
    textAnchor: "middle"
  }, "FESTIVAL SEASON")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 120,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#E65100",
    textAnchor: "middle"
  }, "20% OFF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 150,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#5D4037",
    textAnchor: "middle"
  }, "Celebrate with extra savings on all products!")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFestivalSeason);
export default __webpack_public_path__ + "static/media/festival_season.42ce75cf301ab0e7b03b403f300ffb87.svg";
export { ForwardRef as ReactComponent };